import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

import {SectionProps} from '../../types/form';

const REGIONS = [
    {id: 1, label: 'Sul do País'},
    {id: 2, label: 'Norte'},
    {id: 3, label: 'Nordeste'},
    {id: 4, label: 'Centro-Oeste'},
    {id: 5, label: 'Sudeste'},
    {id: 6, label: 'Mercosul'},
];


const Section6 = (props: SectionProps) => {

    const {handleNext, values, setValues} = props;

    return (
        <Box>
            <Typography variant={'h2'}>
                Para onde já viajou?
            </Typography>

            <Stack direction={'column'} spacing={3}>

                <FormControl fullWidth>
                    <FormGroup>
                        {REGIONS.map(region => (
                            <FormControlLabel
                                key={region.id}
                                control={<Checkbox
                                    size={'small'}
                                    sx={{py: 0.3}}
                                    checked={values['traveled_regions'].includes(region.id)}
                                    onChange={(e) => {
                                        let traveled_regions = values['traveled_regions'];
                                        if (e.target.checked) {
                                            traveled_regions = [...traveled_regions, region.id];
                                        } else {
                                            traveled_regions = traveled_regions.filter(id => id !== region.id);
                                        }
                                        setValues({
                                            ...values,
                                            traveled_regions: traveled_regions,
                                        });
                                    }}
                                />}
                                label={region.label}
                            />
                        ))}
                    </FormGroup>
                </FormControl>

            </Stack>

            <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                <Button variant={'contained'} onClick={handleNext}>
                    Próximo
                    <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                </Button>
            </Stack>
        </Box>
    );
};

export default Section6;
